import React, { createContext, useReducer } from 'react'
import { auditQuestionReducer, auditTaskReducer, taskReducer } from '../reducer/auditReducer'
import { contentQuestionReducer, trainingCategoryContentReducer, trainingCategoryReducer } from '../reducer/learningAndDevelopmentReducer'
import uploadDataReducer from '../reducer/uploadDataReducer'

export const OtherContext = createContext({})

export const OtherContextProvider = ({ children }) => {
  const [uploadedData, uploadedDataDispatch] = useReducer(uploadDataReducer, { uploadData: false, loading: false })
  const [auditQuestionData, auditQuestionDataDispatch] = useReducer(auditQuestionReducer, { auditQuestions: false, loading: false })

  const [trainingCategory, trainingCategoryDispatch] = useReducer(trainingCategoryReducer, { trainingCategories: false, loading: false })
  const [contentQuestion, contentQuestionDispatch] = useReducer(contentQuestionReducer, { contentQuestions: false, loading: false })
  const [task, taskDispatch] = useReducer(taskReducer, { tasks: false, loading: false })
  const [auditTask, auditTaskDispatch] = useReducer(auditTaskReducer, { auditTasks: false, loading: false })

  const [trainingCategoryContent, trainingCategoryContentDispatch] = useReducer(trainingCategoryContentReducer, { trainingCategoryContents: false, loading: false })

  function getAllUploadedData(data) {
    uploadedDataDispatch({
      type: 'GET_ALL_UPLOAD_DATA',
      payload: data,
    })
  }

  function getAllAuditQuestions(data) {
    auditQuestionDataDispatch({
      type: 'GET_ALL_AUDITQUESTION',
      payload: data,
    })
  }

  function getAllAuditTasks(data) {
    auditTaskDispatch({
      type: 'GET_ALL_AUDIT_TASK',
      payload: data,
    })
  }

  function getAllTask(data) {
    taskDispatch({
      type: 'GET_ALL_TASK',
      payload: data,
    })
  }

  function getAllTrainingCategories(data) {
    trainingCategoryDispatch({
      type: 'GET_ALL_TRAININGCATEGORY',
      payload: data,
    })
  }

  function getAllTrainingCategoryContent(data) {
    trainingCategoryContentDispatch({
      type: 'GET_ALL_TRAININGCATEGORYCONTENT',
      payload: data,
    })
  }

  function deleteTrainingCategoryContent(data) {
    trainingCategoryContentDispatch({
      type: 'DELETE_TRAININGCATEGORYCONTENT',
      payload: data,
    })
  }
  function deleteTrainingCategory(data) {
    trainingCategoryDispatch({
      type: 'DELETE_TRAININGCATEGORY',
      payload: data,
    })
  }

  function getAllContentQuestion(data) {
    contentQuestionDispatch({
      type: 'GET_ALL_CONTENTQUESTION',
      payload: data,
    })
  }

  function addContentQuestion(data) {
    contentQuestionDispatch({
      type: 'GET_ALL_CONTENTQUESTION',
      payload: data,
    })
  }

  function deleteContentQuestion(data) {
    contentQuestionDispatch({
      type: 'DELETE_CONTENTQUESTION',
      payload: data,
    })
  }

  return (
    <OtherContext.Provider
      value={{
        getNewUploadedData: getAllUploadedData,
        uploadedData: uploadedData.uploadData,
        getNewAuditQuestion: getAllAuditQuestions,
        auditQuestions: auditQuestionData.auditQuestions,
        getNewTrainingCategory: getAllTrainingCategories,
        deleteNewTrainingCategory: deleteTrainingCategory,
        trainingCategories: trainingCategory.trainingCategories,
        getNewTrainingCategoryContent: getAllTrainingCategoryContent,
        deleteNewTrainingCategoryContent: deleteTrainingCategoryContent,
        trainingCategoryContents: trainingCategoryContent.trainingCategoryContents,
        getNewContentQuestion: getAllContentQuestion,
        deleteNewContentQuestion: deleteContentQuestion,
        contentQuestions: contentQuestion.contentQuestions,
        addNewQuiz: addContentQuestion,
        getNewTask: getAllTask,
        tasks: task.tasks,
        getNewAuditTask: getAllAuditTasks,
        auditTasks: auditTask.auditTasks,
      }}
    >
      {children}
    </OtherContext.Provider>
  )
}
